import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';

interface Props {
  open: boolean;
  onClose: () => void;
  currentName: string;
  onConfirm: (name: string) => void;
}

const RenameModal: React.FC<Props> = ({ open, onClose, currentName, onConfirm }) => {
  const [name, setName] = useState(currentName);

  useEffect(() => {
    if (open) setName(currentName);
  }, [open, currentName]);

  const handleOk = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
    onClose();
  };

  return (
    <Modal
      title="Đổi tên"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText="Lưu"
      cancelText="Hủy"
      okButtonProps={{ disabled: !name.trim() }}
      width={400}
    >
      <div className="rename-modal">
        <input
          type="text"
          className="rename-modal__input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleOk()}
          autoFocus
          maxLength={80}
        />
      </div>
    </Modal>
  );
};

export default RenameModal;
